<template>
  <div class="info-content flex flex-center flex-column">
    <p class="win-hit">
      <!-- 恭喜你获得<br>
      <span class="color-jin">【力高定制U盘】</span>一个 -->
      {{ prize_title }}
    </p>
    <input type="text" class="input-text" placeholder="姓名" v-model.trim="name" @blur="blurFn" @focus="focusFn">
    <input type="text" class="input-text" placeholder="手机号码" v-model="phone" @blur="blurFn" @focus="focusFn">
    <input type="text" class="input-text" placeholder="收货地址" v-model.trim="city" @blur="blurFn" @focus="focusFn">
    <!-- <div class="formmsg-select">
      <p class="formmsg-select-text" :class="{'fst-no': city === ''}">{{ city === '' ? '兑奖地点' : city }}</p>
      <select class="formmsg-select-box" v-model="city" @blur="blurFn" @focus="focusFn">
        <option value="惠州蓝光·雍和园营销中心">惠州蓝光·雍和园营销中心</option>
        <option value="惠州蓝光·铂汇公馆营销中心">惠州蓝光·铂汇公馆营销中心</option>
        <option value="茂名蓝光·高州钰瀧湾营销中心">茂名蓝光·高州钰瀧湾营销中心</option>
        <option value="茂名蓝光·雍锦半岛营销中心">茂名蓝光·雍锦半岛营销中心</option>
        <option value="茂名蓝光·滨海钰瀧湾营销中心">茂名蓝光·滨海钰瀧湾营销中心</option>
      </select>
    </div> -->
    <button class="btn btn-1" @click="submitFn">提交信息</button>
    <img src="../../assets/images/39.png" class="img-5">
  </div>
</template>

<script>
export default {
  name: 'Info',
  data () {
    return {
      timeId: '',
      os: this.$util.getOS(),
      name: this.$store.state.userInfo.name || '',
      phone: this.$store.state.userInfo.phone || '',
      city: this.$store.state.userInfo.address || ''
    }
  },
  computed: {
    prize_title () {
      return this.$store.state.prize_title
    },
    pageName () {
      return this.$store.state.pageName
    }
  },
  inject: ['slideHandle', 'infoHandle'],
  methods: {
    focusFn () {
      if (!this.os.iPhone) return
      clearTimeout(this.timeId)
    },
    blurFn () {
      if (!this.os.iPhone) return
      this.timeId = setTimeout(() => {
        window.scrollTo(0, 0)
      }, 300)
    },
    submitFn () {
      if (this.name === '') {
        this.$alert.warn('请填写姓名')
        return false
      } else if (this.phone === '') {
        this.$alert.warn('请填写手机号码')
        return false
      } else if (this.phone.length !== 11) {
        this.$alert.warn('手机号码格式错误')
        return false
      } else if (this.city === '') {
        this.$alert.warn('请填写收货地址')
        return false
      } else {
        this.$alert.load()
        this.$http.saveMissUser({
          name: this.name,
          phone: this.phone,
          address: this.city
        }).then(res => {
          this.$alert.close()
          if (res.status === 1) {
            this.$store.state.userInfo.name = this.name
            this.$store.state.userInfo.phone = this.phone
            this.$store.state.userInfo.address = this.city

            this.infoHandle(false)
            this.$alert.msg('提交成功')
            if (this.pageName === 'Lottery') {
              setTimeout(() => {
                this.slideHandle(2)
              }, 500)
            }
          } else {
            this.$alert.warn(res.msg)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.info-content {
  height: 9.2rem;
}
.formmsg-select,
.input-text {
  position: relative;
  display: block;
  width: 4.45rem;
  height: .7rem;
  margin: .1rem 0;
  padding: .1rem .2rem;
  border-radius: .1rem;
  border: 0;
  outline: none;
  font-size: .24rem;
  color: #333;
  background-color: rgba(255, 255, 255, 1);
}
.input-text::-webkit-input-placeholder { /* WebKit browsers */
    color: rgba(51, 51, 51, .5);
}
.input-text:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(51, 51, 51, .5);
}
.input-text::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(51, 51, 51, .5);
}
.input-text:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: rgba(51, 51, 51, .5);
}
.img-5 {
  display: block;
  width: 4.36rem;
}
.btn-1 {
  margin: .4rem 0;
}
.formmsg-select-text {
  height: 100%;
  line-height: .5rem;
}
.formmsg-select-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.formmsg-select-box option {
  width: 100%;
}
.fst-no {
  color: rgba(51, 51, 51, .5);
}
.win-hit {
  margin-bottom: .4rem;
  padding: 0 .8rem;
  font-size: .3rem;
  color: #fff;
  text-align: center;
  font-weight: bold;
  white-space: pre-line;
}
</style>
